const enum StrapiCollection {
  SPLASH_PROMO_CAROUSEL = 'splash-promo-carousels',
  HOME_PROMO_FEATURED_CONTESTS = 'homepage-promo-featureds',
  HOME_PROMO_CUSTOM_CONTESTS = 'homepage-promo-custom-contests',
  TUTORIAL = 'tutorials',
  AUTH_SIGN_UP_SLIDESHOW = 'auth-sign-up-slideshows',
  GLOSSARIES = 'glossaries',
  ALTERNATES = 'alternates',
}

export { StrapiCollection };
